// src/pages/UnauthorizedPage.tsx
import React, { useEffect, useRef } from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * 権限がない場合に表示されるページ。
 * 管理Webは admin 専用のため、表示時にログアウトする。
 */
const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const didLogoutRef = useRef(false);

  useEffect(() => {
    if (didLogoutRef.current) return;
    didLogoutRef.current = true;
    void logout().catch((error) => {
      console.error('ログアウトエラー:', error);
    });
  }, [logout]);

  return (
    <div className="unauthorized-container">
      <Result
        status="403"
        title="アクセス権限がありません"
        subTitle="管理Webは admin ロールのユーザーのみ利用できます。ログインし直すか、管理者にお問い合わせください。"
        extra={[
          <Button type="primary" key="login" onClick={() => navigate('/login', { replace: true })}>
            ログイン画面へ
          </Button>,
        ]}
      />
    </div>
  );
};

export default UnauthorizedPage;
